<header class="header-area bg-white border-radius transition" [ngClass]="{ active: isSidebarToggled, sticky: isSticky }"
  [class.component-dark-theme]="themeService.isDark()" [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()" [class.dark-header]="themeService.isHeaderDark()"
  [class.card-borderd-theme]="themeService.isCardBorder()" [class.rtl-enabled]="themeService.isRTLEnabled()">
  <div class="d-flex align-items-center justify-content-between">
    <div class="header-left-side d-flex align-items-center">
      <div class="burger-menu cursor-pointer transition d-xl-none" [ngClass]="{ active: isSidebarToggled }"
        (click)="toggle()">
        <span class="top-bar d-block bg-black transition"></span>
        <span class="middle-bar d-block bg-black transition"></span>
        <span class="bottom-bar d-block bg-black transition"></span>
      </div>
      <span class="d-inline-block fw-medium text-capitalize">
        {{ displayName }}
      </span>
    </div>
    <div class="input--container">
      <input readonly type="text" placeholder="Ctrl + K | Search Menus" (focus)="openMenuSearch()" />
    </div>
    <ul class="header-right-side d-flex align-items-center mt-0 mb-0 pl-0 list-unstyled">
      <li>
        <!-- Admin Dashboard Mail -->
        <button *ngIf="userType === 0" routerLink="/admin-dashboard/message-panel" mat-icon-button
          class="messages-menu-btn p-0">
          <i class="material-symbols-outlined"> mail </i>
          <span *ngIf="unreadCount > 0" class="daxa-badge">{{
            unreadCount
            }}</span>
        </button>

        <!-- College Admin Dashboard Mail -->
        <button *ngIf="userType === 8" routerLink="/college-admin-dashboard/message-panel" mat-icon-button
          class="messages-menu-btn p-0">
          <i class="material-symbols-outlined"> mail </i>
          <span *ngIf="unreadCount > 0" class="daxa-badge">{{
            unreadCount
            }}</span>
        </button>

        <!-- Student Dashboard Mail -->
        <button *ngIf="userType === 1" routerLink="/student-dashboard/message-panel" mat-icon-button
          class="messages-menu-btn p-0">
          <i class="material-symbols-outlined"> mail </i>
          <span *ngIf="unreadCount > 0" class="daxa-badge">{{
            unreadCount
            }}</span>
        </button>
      </li>

      <li>
        <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
          <img src="images/embelem.png" alt="profile-image" />
          <span class="status d-inline-block rounded-circle position-absolute"></span>
        </button>
        <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
          <div [class.dark-menu]="
              themeService.isDark() || themeService.isHeaderDark()
            ">
            <div class="menu-header d-flex align-items-center">
              <img src="images/admin.png" alt="profile-image" />
              <div class="title">
                <a *ngIf="userType === 0" routerLink="/student-dashboard/my-profile" class="d-inline-block fw-medium">
                  {{ displayName }}
                </a>
                <a *ngIf="userType === 1" routerLink="/student-dashboard/my-profile" class="d-inline-block fw-medium">
                  {{ displayName }}
                </a>

                <span class="designation d-block text-body">
                  {{ userName }}
                </span>
              </div>
            </div>
            <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
              <li (click)="toProfile()" class="position-relative transition fw-medium">
                <i class="material-symbols-outlined"> person </i>
                My Profile
                <a class="link-btn d-block position-absolute"></a>
              </li>
              <li class="position-relative transition fw-medium">
                <i class="material-symbols-outlined"> settings </i>
                System Settings
                <a routerLink="settings/security" class="link-btn d-block position-absolute"></a>
              </li>
              <!-- <li class="position-relative transition fw-medium">
                <i class="material-symbols-outlined"> info </i>
                Support
                <a routerLink="/settings/connections" class="link-btn d-block position-absolute"></a>
              </li> -->
              <li (click)="logout()" class="position-relative transition fw-medium">
                <i class="material-symbols-outlined"> logout </i>
                Logout
                <a class="link-btn d-block position-absolute"></a>
              </li>
            </ul>
          </div>
        </mat-menu>
      </li>
    </ul>
  </div>
</header>